export default "__VITE_ASSET__hZNIniPN__"